import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { queryParamSelector, RouterAction } from '@cbridge-packages/routing';
import { StreamParam } from '../_helpers/streamSearchParam';
import { StreamsFilterAction } from '../streamsFilter.action';

type IState =
  & IGetSelectorStateType<typeof queryParamSelector>;

export const toggleSelectStreamEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(StreamsFilterAction.toggleSelect),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { streamId } = payload;
    const currentId = queryParamSelector(state, StreamParam.name);

    if (String(streamId) === currentId) {
      return [
        RouterAction.removeParam(StreamParam.name),
      ];
    }
    return [
      RouterAction.addParam(StreamParam.nameAndValue(String(streamId))),
    ];
  }),
);
